import React from "react";
import {
  PageNewState,
  DeploymentRequestInfomationInputDialogInitialState,
} from ".";

export const DeploymentRequestInfomationInputDialogContext =
  React.createContext({
    pageState: DeploymentRequestInfomationInputDialogInitialState,
    setPageState: (pageState: PageNewState) => {},
  });
